import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
const InfoModalOrg = ({ open, setOpen }: { open: any, setOpen: any }) => {
    return (

        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            sx={{ "& .MuiDialog-paper": { width: "70vw", maxWidth: "800px" } }}
        >
            <DialogTitle className="flex flex-row justify-between items-center bg-gray-100 h-7">
                <div className="flex flex-row gap-3 items-center">
                    <InfoOutlinedIcon sx={{ color: 'blue' }} />
                    <p>Info</p>
                </div>
                <CloseOutlinedIcon onClick={() => setOpen(false)} className='cursor-pointer' sx={{ color: "red" }} />
            </DialogTitle>

            <DialogContent className='mt-5 '>
                <div className='flex flex-col gap-3'>
                    <div>
                        <h2 className='font-bold'>Prevent Multi Device Login</h2>
                        <div>{"Login on first device (mobile/web) => Works fine (session started)"}</div>
                        <div>{"Login on second device => First device is logged out, second device is logged in"}</div>
                        <div>{"Previous session ended"}</div>
                        <div>{"New session started"}</div>
                    </div>

                    <div>
                        <h2 className='font-bold'>Prevent Multiple Login</h2>
                        <div>{"Login on first device (mobile/web) => Works fine"}</div>
                        <div>{"Login on second device => Fails with message: 'Please logout from your previous device'"}</div>
                    </div>

                    <div>
                        <h2 className='font-bold'>Prevent Multiple Login With Restrictions</h2>
                        <div>{"Login on phone => Works fine"}</div>
                        <div>{"Login on web => Also works fine"}</div>
                        <div>{"Login again on another phone => First phone is logged out, new phone is logged in"}</div>
                        <div>{"Login again on web => Previous web session is logged out, new session started"}</div>
                    </div>

                    <div>
                        <h2 className='font-bold'>Prevent Multiple Devices Login With Restrictions</h2>
                        <div>{"Login on phone => Works fine"}</div>
                        <div>{"Login on web => Works fine"}</div>
                        <div>{"Login again on another phone => Fails with message: 'Please logout from your previous device'"}</div>
                        <div>{"Login again on web => Fails with message: 'Please logout from your previous device'"}</div>
                    </div>
                </div>

            </DialogContent>
        </Dialog >
    )
}

export default InfoModalOrg
